// extracted by mini-css-extract-plugin
export default {"input":"InputField_input__pAX4T","group":"InputField_group__hy80I"};